<template xmlns="http://www.w3.org/1999/html">
  <div class="container">
    <a-card>
      <a-row>
        <a-col :span="24">
          <div class="card-title">
            <h2>Customer Dashboard</h2>
          </div>

          <!-- Watchlist bookings -->
          <a-row v-if="watchlistOutgoingBookings.length">
            <a-collapse v-model="activeKey" :bordered="false">
              <a-collapse-panel
                key="1"
                header="Watchlist Of Outgoing Freight"
                class="collapse-panel"
              >
                <div class="collapse-body">
                  <bookings-dashboard-sender
                    booking-type="outgoing"
                    :load-status="bookingsLoadStatus"
                    :bookings="watchlistOutgoingBookings"
                    empty-text="There are no bookings currently on your watchlist. You can click the star next to any booking to add it to your watchlist."
                  />
                </div>
              </a-collapse-panel>
            </a-collapse>
          </a-row>

          <a-row v-if="watchlistIncomingBookings.length">
            <a-collapse v-model="activeKey" :bordered="false">
              <a-collapse-panel
                key="2"
                header="Watchlist Of Incoming Freight"
                class="collapse-panel"
              >
                <bookings-dashboard-sender
                  booking-type="incoming"
                  :load-status="bookingsLoadStatus"
                  :bookings="watchlistIncomingBookings"
                  empty-text="There are no bookings currently on your watchlist. You can click the star next to any booking to add it to your watchlist."
                />
              </a-collapse-panel>
            </a-collapse>
          </a-row>

          <!-- Outgoing bookings -->
          <a-row>
            <a-collapse v-model="activeKey" :bordered="false">
              <a-collapse-panel
                key="3"
                header="Outgoing Freight"
                class="collapse-panel"
              >
                <bookings-dashboard-sender
                  booking-type="outgoing"
                  :load-status="bookingsLoadStatus"
                  :bookings="outgoingBookings"
                />
              </a-collapse-panel>
            </a-collapse>
          </a-row>

          <!-- Incoming bookings -->
          <a-row v-if="incomingBookings.length">
            <a-collapse v-model="activeKey" :bordered="false">
              <a-collapse-panel
                key="4"
                header="Incoming Freight"
                class="collapse-panel"
              >
                <a-col>
                  <bookings-dashboard-sender
                    booking-type="incoming"
                    :load-status="bookingsLoadStatus"
                    :bookings="incomingBookings"
                  />
                </a-col>
              </a-collapse-panel>
            </a-collapse>
          </a-row>
        </a-col>
        <a-col v-if="false" :span="0">
          <events-dashboard-sender />
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<script>
import BookingsDashboardSender from "../../components/tables/BookingsDashboardSender";
import BookingSearch from "../../components/global/BookingSearch";
import EventsDashboardSender from "../../components/cards/EventsDashboardSender";

export default {
  name: "DashBoard",
  components: {
    BookingsDashboardSender,
    BookingSearch,
    EventsDashboardSender
  },
  data() {
    return {
      activeKey: ["1", "2", "3", "4"]
    };
  },
  created() {
    this.$store.dispatch("loadBookings");
    this.$store.dispatch("loadDefaultPickupLocation");
  },
  computed: {
    bookingsLoadStatus() {
      return (
        this.$store.getters.getBookingsLoadStatus === 1 ||
        this.$store.getters.getDefaultPickupLocationLoadStatus === 1
      );
    },
    outgoingBookings() {
      return this.$store.getters.getOutgoingBookings;
    },
    incomingBookings() {
      return this.$store.getters.getIncomingBookings;
    },
    watchlistBookings() {
      return this.$store.getters.getWatchlistBookings;
    },
    watchlistOutgoingBookings() {
      return this.$store.getters.getWatchlistOutgoingBookings;
    },
    watchlistIncomingBookings() {
      return this.$store.getters.getWatchlistIncomingBookings;
    }
  }
};
</script>

<style scoped>
.ant-card {
  margin-top: 2rem;
  border-radius: 10px;
  box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.2);
}

.ant-card .card-title {
  font-weight: bold;
  color: #3d3d3d;
  margin-bottom: 2rem;
  padding-left: 1rem;
}

.ant-collapse {
  background: white;
  margin-bottom: 1rem;
}

.ant-collapse .ant-collapse-item {
  border-bottom: 0;
}

.collapse-panel {
  font-weight: 500;
  font-size: 1.5rem;
  color: #3d3d3d;
}

>>> .autocomplete__results {
  width: auto;
}

.sub-title {
  color: rgb(74, 85, 104);
  font-weight: 500;
  line-height: 26px;
  font-size: 1.2rem;
  display: inline-block;
}
</style>
